import React from "react";
import {
  Stack,
  Typography,
  FormControlLabel,
  Checkbox,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { PurchaseChannel } from "@quest_editor/mocks";

const PurchaseChannelField = ({
  purchaseChannels,
  purchaseChannelIds,
  setPurchaseChannelIds,
  emptyLabel,
}: {
  purchaseChannels: PurchaseChannel[];
  purchaseChannelIds: string[];
  setPurchaseChannelIds: React.Dispatch<React.SetStateAction<string[]>>;
  emptyLabel: string;
}) => {
  const handlePurchaseChannelChange =
    (id: string) =>
    (_e: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
      checked
        ? setPurchaseChannelIds((prev: string[]) =>
            prev.includes(id) ? prev : [...prev, id],
          )
        : setPurchaseChannelIds((prev: string[]) =>
            prev.filter((pid) => pid !== id),
          );
    };

  return (
    <Accordion
      sx={{
        ".MuiAccordionSummary-root .MuiSvgIcon-root": {
          transform: "rotate(0deg)",
        },
      }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        {purchaseChannelIds.length > 0 ? (
          <Typography color="primary">
            {purchaseChannels
              .filter((p) => purchaseChannelIds.includes(p.id))
              .map((p) => p.name)
              .join(", ")}
          </Typography>
        ) : (
          <Typography color="primary">{emptyLabel}</Typography>
        )}
      </AccordionSummary>
      <AccordionDetails>
        <Stack direction="row" sx={{ flexWrap: "wrap" }}>
          {purchaseChannels.map((p) => (
            <FormControlLabel
              control={
                <Checkbox
                  checked={purchaseChannelIds.includes(p.id)}
                  onChange={handlePurchaseChannelChange(p.id)}
                />
              }
              label={p.name}
              sx={{ color: "text.secondary" }}
            />
          ))}
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
};

export default PurchaseChannelField;
